// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Gap-gap-a526{flex:0 0 auto}`, "",{"version":3,"sources":["webpack://./src/component/Space/Gap.module.scss"],"names":[],"mappings":"AAAA,cACE,aAAA","sourcesContent":[".gap {\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gap": `Gap-gap-a526`
};
module.exports = ___CSS_LOADER_EXPORT___;
